import { NAV_ICONS } from "../components/ui/icons";

export const PLATFORM_BOTTOM_TABS = [
  { id: "overview", to: "/admin", end: true, label: "Сводка", icon: "overview" },
  { id: "tenants", to: "/admin/tenants", label: "Клубы", icon: "clients" },
  { id: "support", to: "/admin/support", label: "Чат", icon: "chat" },
  { id: "more", to: "/admin/more", label: "Ещё", icon: "settings" },
];

export const PLATFORM_MORE_LINKS = [
  { id: "leads", to: "/admin/leads", label: "Лиды", icon: "funnel" },
  { id: "funnel", to: "/admin/funnel", label: "Воронка", icon: "funnel" },
  { id: "payments", to: "/admin/payments", label: "Оплаты", icon: "finance" },
  { id: "plans", to: "/admin/plans", label: "Тарифы", icon: "memberships" },
  { id: "notifications", to: "/admin/notifications", label: "Уведомления", icon: "notifications" },
  { id: "audit", to: "/admin/audit", label: "Журнал", icon: "journal" },
];

export function resolvePlatformPageTitle(pathname) {
  const path = String(pathname || "").replace(/\/$/, "") || "/admin";
  if (path === "/admin") return "Сводка";
  if (path.startsWith("/admin/funnel")) return "Воронка";
  if (path.startsWith("/admin/tenants/")) return "Клуб";
  if (path.startsWith("/admin/tenants")) return "Клубы";
  if (path.startsWith("/admin/leads")) return "Лиды";
  if (path.startsWith("/admin/onboarding-emails")) return "Письма";
  if (path.startsWith("/admin/payments")) return "Оплаты";
  if (path.startsWith("/admin/support")) return "Поддержка";
  if (path.startsWith("/admin/plans")) return "Тарифы";
  if (path.startsWith("/admin/notifications")) return "Уведомления";
  if (path.startsWith("/admin/audit")) return "Журнал";
  if (path.startsWith("/admin/more")) return "Ещё";
  return "Платформа";
}

export function resolvePlatformBottomTab(pathname) {
  const path = String(pathname || "").replace(/\/$/, "") || "/admin";
  if (path === "/admin" || path === "/admin/") return "overview";
  if (path.startsWith("/admin/tenants")) return "tenants";
  if (path.startsWith("/admin/funnel")) return "more";
  if (path.startsWith("/admin/support")) return "support";
  if (
    path.startsWith("/admin/more") ||
    path.startsWith("/admin/plans") ||
    path.startsWith("/admin/leads") ||
    path.startsWith("/admin/audit") ||
    path.startsWith("/admin/payments") ||
    path.startsWith("/admin/notifications")
  ) {
    return "more";
  }
  return "overview";
}

export function isPlatformChatConversation(pathname) {
  const path = String(pathname || "");
  return /^\/admin\/support\/[^/]+/.test(path);
}

export function platformNavIcon(key) {
  return NAV_ICONS[key] || NAV_ICONS.overview;
}
